export default "__VITE_ASSET__CQR4YPWz__"